module.exports = __webpack_public_path__ + "img/map-bg.48ef6bfc.png";